<template>
  <button type="button" class="select-btn" :disabled="disabled" @click="$emit('click')">
    <span v-if="isConnecting">{{ $t('connecting') }} 🌐</span>
    <span v-else-if="isConnected">{{ $t('connected') }} 🔗</span>
    <span v-else-if="connectFailed">{{ $t('retry') }} ↻</span>
    <span v-else-if="socketClosed">{{ $t('connect') }} ➜</span>
    <span v-else-if="isLanguageChanged">{{ $t('reconnect') }} ↻</span>
    <span v-else>{{ $t('connect') }}</span>
  </button>
</template>

<script>
export default {
  name: 'ConnectButton',
  props: {
    isConnecting: Boolean,
    isConnected: Boolean,
    connectFailed: Boolean,
    socketClosed: Boolean,
    isLanguageChanged: Boolean,
    disabled: Boolean
  }
};
</script>

<style scoped>
.select-btn {
  font-family: 'Montserrat';
  padding: 16px 24px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  width: 100%;
  border: none;
  background-color: var(--primary-color);
  color: var(--reverse-color);
  cursor: pointer;
  transition: background-color 0.3s;
}

.select-btn:disabled {
  background-color: var(--disabled-color);
  color: var(--secondary-color);
  cursor: not-allowed;
}
</style>